import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import { countThirdPartyVehiclesService } from "../services/countThirdPartyVehicles.service.js";
import debounce from "lodash.debounce";

export const useCountThirdPartyVehiclesQuery = (filters) => {
  const fetchData = useFetch();
  const [countThirdPartyVehicles, setCountThirdPartyVehicles] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        setLoading(true);
        const response = await countThirdPartyVehiclesService(fetchData)({
          filters,
        });

        setCountThirdPartyVehicles(response.thirdParties);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    const debounced = debounce(fetchCount, 500);
    debounced();

    return () => {
      debounced.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, filters?.startDate, filters?.endDate]);

  return {
    countThirdPartyVehicles,
    loading,
    refresh: () => setRefresh((prev) => !prev),
  };
};
